module.exports = __webpack_public_path__ + "img/login_mobile.8960506c.jpg";